class GiftMessage extends HTMLElement {
  connectedCallback() {
    this.checkbox?.addEventListener('change', this.handleToggle);
    this.form?.addEventListener('submit', this.handleBeforeSubmit, { capture: true });
    this.form?.addEventListener('formdata', this.handleFormData);

    this.sync();
  }

  disconnectedCallback() {
    this.checkbox?.removeEventListener('change', this.handleToggle);
    this.form?.removeEventListener('submit', this.handleBeforeSubmit, { capture: true });
    this.form?.removeEventListener('formdata', this.handleFormData);
  }

  handleToggle = () => {
    this.sync();
  };

  handleBeforeSubmit = () => {
    this.sync();
  };

  handleFormData = (event) => {
    const propertyName = this.propertyInput?.dataset.propertyName;
    const propertyValue = this.propertyInput?.dataset.propertyValue || 'yes';

    if (!this.isActive || !propertyName) {
      event.formData.delete(propertyName);
      return;
    }

    event.formData.set(propertyName, propertyValue);
  };

  sync() {
    const input = this.propertyInput;
    const propertyName = input?.dataset.propertyName;
    const propertyValue = input?.dataset.propertyValue || 'yes';
    const shouldSubmit = this.isActive && !!propertyName;

    if (input && propertyName) {
      input.value = propertyValue;

      if (shouldSubmit) {
        input.name = propertyName;
        input.disabled = false;
      } else {
        input.disabled = true;
        input.removeAttribute('name');
      }
    }
  }

  get isActive() {
    return this.checkbox?.checked === true;
  }

  get form() {
    return this.closest('form');
  }

  get checkbox() {
    return this.querySelector('[data-gift-message-toggle]');
  }

  get propertyInput() {
    return this.querySelector('[data-gift-property]');
  }
}

if (!customElements.get('gift-message')) {
  customElements.define('gift-message', GiftMessage);
}
